import { z } from 'zod';

import { PlatformUserRole, PlatformUserStatus } from '@nucleus-commerce/api-client/platform';

/** Form behind PATCH /platform/v1/users/:id; the mapper sends only the fields that changed. */
export const editUserSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { error: 'users:validation.required' })
    .max(120, { error: 'users:validation.nameMax' }),
  role: z.enum(PlatformUserRole),
  status: z.enum(PlatformUserStatus),
});

export type EditUserInput = z.input<typeof editUserSchema>;
export type EditUserOutput = z.output<typeof editUserSchema>;
